// angular
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';
import { AppService } from '../../../app.service';
import { MePaymentService } from '../me-payment.service';

@Component({
    selector: 'me-payment-coupon-card',
    templateUrl: './coupon-card.component.html',
    styleUrls: ['./coupon-card.component.scss']
})

export class MePaymentCouponCardComponent implements OnInit {
    form: FormGroup;
    submitted = false;
    errorAge = false;
    errorMessage = '';
    dateFormat: string = 'DD.MM.YYYY';
    url = 'payment/coupon-card';
    data = [];
    packageData = [];
    addCoupon = false;
    articleId = 0;
    amount = 0;
    amountDisplay = '0';
    amountWithoutTax = 0;
    amountWithoutTaxDisplay = '0';
    taxAmount = 0;
    taxAmountDisplay = '0';
    taxPercent = 0;
    currency = 'EUR';
    discountPercent = 0;
    newPrice = 0;
    newPriceDisplay = '0';
    discountPrice = 0;
    discountPriceDisplay = '0';
    type = '';

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public route: ActivatedRoute,
        public coreService: CoreService,
        public mePaymentService : MePaymentService
    ) {

    }

    ngOnInit() {
        this.getContentCouponCard();
        this.translate.onLangChange.subscribe(value => {
            this.getContentCouponCard();
            this.getPackageName();
            this.getCurrencyFormat();
        });
    
        this.form = this.fb.group({
            code: ['', [Validators.required, Validators.minLength(6)]],
        });

        this.route.queryParams.subscribe(params => {
            this.type = params['articleType'];
            this.mePaymentService.articleType = this.type;
            this.mePaymentService.getPaymentInfo(this.type).subscribe(res => {
                this.currency = res['currency'];
                this.amount = res['amount'];
                this.amountWithoutTax = res['amountWithoutTax'];
                this.taxAmount = res['taxAmount'];
                this.taxPercent = res['taxPercent'];
                this.getCurrencyFormat();
                this.appService.isLoading = false;
            });
            this.getPackageName();
        })
    }

    getContentCouponCard() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
        });
    }

    getPackageName() {
        this.appService.getStoryBlokDataForClinic('packages/' + this.type).subscribe(res => {
            this.packageData = res['story']['content'] ?? [];
        });
    }

    getCurrencyFormat() {
        this.taxAmountDisplay = this.coreService.formatCurrency(this.taxAmount, this.currency);
        this.amountWithoutTaxDisplay = this.coreService.formatCurrency(this.amountWithoutTax, this.currency);
        this.amountDisplay = this.coreService.formatCurrency(this.amount, this.currency);
    }

    submit(data, isValid) {
        this.submitted = true;
        if (!isValid || this.errorAge) {
            return;
        }
        
        this.errorMessage = '';
        data['article_type'] = this.mePaymentService.articleType;
        this.mePaymentService.checkCoupon(data).subscribe((res) => {
            this.errorMessage = this.data[res['message'] + 'ErrorText'];

            if (res['percent_discount']) {
                this.discountPercent = res['percent_discount'];
                this.discountPrice = this.amount * (this.discountPercent / 100);
                this.newPrice = this.amount - this.discountPrice;
                this.discountPriceDisplay = this.coreService.formatCurrency(this.discountPrice, this.currency);
                this.newPriceDisplay = this.coreService.formatCurrency(this.newPrice, this.currency);
                this.mePaymentService.couponCode = data['code'];
            }
        });
    }
}
